import closePaneAndRevealAssets from './_closePaneAndRevealAssets';

export default {
    verb: 'didCreate',
    namespace: 'transaction',
    relation: 'itemByTagId',
    description:
        'collapse the "Create From RFID Tag" detail pane and reveal the generated asset on save-success',
    logic: closePaneAndRevealAssets
};

// The create form for Serialized-Each single tag-id POST renders in a detail pane on the
// Assets grid: an item:item DetailPane (showForAction: 'newFromTag') hosting a self-managing
// SingleRecordForm on the virtual transaction:itemByTagId relation. On save-success the
// server bridge (didCreate_transaction_itemByTagId) re-dispatches the POST to an item:item
// create; the generated asset arrives via socket notifications. closePaneAndRevealAssets clears
// the host item:item ActiveRecord to collapse the pane, then resets the #332 display gate on
// item:item so the new asset appears without a manual sync (see _closePaneAndRevealAssets).
